new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#product-detail',
    data: {
        // Showcase
        showOpened: false,
        expandDesc: false,
        installmentOpened: false,

        //Thumb
        imgSrc: '',
        imgTitle: '',
        isVideo: ''
    },
    methods: {
        resizeThumbs() {
            const contentThumbs = document.querySelector('#product-photo');
            const imgThumb = document.querySelector('#product-photo img');
            if (contentThumbs && imgThumb) {
                let heightImg = imgThumb.getBoundingClientRect().height;
                contentThumbs.style.minHeight = heightImg + 'px';
            }
        },
        clickThumbs() {
            let photoArea = document.querySelector('.product-detail__header--photoArea');
            let photoThumbs = document.querySelector('.product-detail__header--photoArea-thumbs');

            if (photoThumbs && photoArea) {
                if (photoArea.classList.contains('gallery-right') || photoArea.classList.contains('gallery-bottom')) {

                    let photoListItem = document.querySelectorAll('#photo-list li');
                    let singlePhotoItem = document.querySelectorAll('#product-photo img, #product-photo video');

                    if (photoListItem.length && singlePhotoItem.length) {
                        photoListItem[0].classList.add('active');
                        singlePhotoItem[0].classList.add('active');

                        function activeTab(index) {
                            // Remove active de todos os photoListItem
                            photoListItem.forEach((item) => {
                                item.classList.remove('active');
                            });
                            // Remove active de todos os singlePhotoItem
                            singlePhotoItem.forEach((content) => {
                                content.classList.remove('active');
                            });
                            // Adiciona active no item clicado e na imagem correspondente
                            photoListItem[index].classList.add('active');
                            singlePhotoItem[index].classList.add('active');
                        }

                        photoListItem.forEach((itemMenu, index) => {
                            itemMenu.addEventListener('click', () => {
                                activeTab(index);
                            });
                        });
                    }
                }
            }
            if (photoThumbs && photoArea) {
                if (photoThumbs.classList.contains('gallery-left') || photoThumbs.classList.contains('gallery-right')) {
                    $('#product-photo').slick({
                        swipeToSlide: true,
                        touchThreshold: 100,
                        arrows: false,
                        dots: false,
                        infinite: false,
                        mobileFirst: true,
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        speed: 300,
                    });

                    // Sincroniza os cliques do #photo-list com o slider do #product-photo
                    let photoListItems = document.querySelectorAll('#photo-list li');

                    if (photoListItems.length) {
                        photoListItems.forEach((item, index) => {
                            item.addEventListener('click', function () {
                                // Remove a classe active de todos os itens
                                photoListItems.forEach(li => li.classList.remove('active'));

                                // Adiciona active no item clicado
                                this.classList.add('active');

                                // Calcula o slide correto considerando o slidesToShow
                                const slidesToShow = 2; // mesmo valor configurado no Slick
                                const totalItems = photoListItems.length;
                                const lastSlideIndex = Math.max(0, totalItems - slidesToShow);

                                // Se o índice ultrapassar o último slide válido, vai para o último
                                const slideIndex = Math.min(index, lastSlideIndex);

                                // Navega para o slide correspondente no #product-photo
                                $('#product-photo').slick('slickGoTo', slideIndex);
                            });
                        });

                        // Adiciona active no primeiro item ao carregar
                        if (photoListItems[0]) {
                            photoListItems[0].classList.add('active');
                        }
                    }
                }
            }

            // if(photoArea.classList.contains('default')) {
            //     if (window.matchMedia("(min-width: 992px)").matches) {
            //         let lastScrollTop = 0;

            //         function animeScroll() {
            //             const photoScroll = document.querySelector('.product-detail__header--photoArea');
            //             const banner = document.querySelector('.product-detail__banner');
            //             const appHeader = document.getElementById('app_header');

            //             if (photoScroll) {
            //                 const infoArea = document.querySelector('.product-detail__header--infoArea');
            //                 const $container = infoArea ? $(infoArea) : $('.product-detail__header--photoArea');
            //                 const containerHeight = $container.outerHeight();
            //                 const containerTop = $container.offset() ? $container.offset().top : 0;
            //                 const sidebarOuterHeight = $('.sidebar__inner').outerHeight();
            //                 const containerWidth = $container.width();
            //                 const totalHeight = containerHeight - sidebarOuterHeight; // deslocamento máximo relativo ao container
            //                 const pageTop = window.scrollY;

            //                 // Verifica se existe banner e calcula quando ele sai da tela
            //                 let bannerOffset = 0;
            //                 if (banner) {
            //                     const bannerRect = banner.getBoundingClientRect();
            //                     const bannerHeight = banner.offsetHeight;
            //                     bannerOffset = bannerHeight;
            //                 }

            //                 // Calcula a altura do header para o top na volta
            //                 let headerHeight = 0;
            //                 if (appHeader) {
            //                     headerHeight = appHeader.offsetHeight;
            //                 }

            //                 // Limites de scroll baseados no container e header
            //                 const safeTotalHeight = Math.max(0, totalHeight);
            //                 const startScroll = containerTop - headerHeight; // ponto para começar a fixar
            //                 const endScroll = containerTop + containerHeight - headerHeight - sidebarOuterHeight; // ponto para parar a fixação

            //                 if (pageTop <= startScroll) {
            //                     // Antes do container tocar o header: posição normal
            //                     $('.sidebar__inner').css({ position: 'relative' });
            //                     $('.sidebar__inner').css({ top: "0px" });
            //                     $('.sidebar__inner').css({ width: "100%" });
            //                     $('.sidebar__inner').css({ maxWidth: "100%" });
            //                 } else if (pageTop >= endScroll) {
            //                     // Depois do final do container: travado no rodapé do container
            //                     $('.sidebar__inner').css({ position: 'relative' });
            //                     $('.sidebar__inner').css({ top: safeTotalHeight + "px" });
            //                     $('.sidebar__inner').css({ width: "100%" });
            //                     $('.sidebar__inner').css({ maxWidth: "100%" });
            //                 } else {
            //                     // Dentro da faixa: fixo logo abaixo do header e com a largura do container
            //                     $('.sidebar__inner').css({ position: 'fixed' });
            //                     $('.sidebar__inner').css({ top: headerHeight + "px" });
            //                     if (containerWidth) {
            //                         $('.sidebar__inner').css({ width: containerWidth + "px" });
            //                         $('.sidebar__inner').css({ maxWidth: containerWidth + "px" });
            //                     }
            //                 }

            //                 lastScrollTop = pageTop;
            //             }
            //         }

            //         window.addEventListener('scroll', function () {
            //             if (screen.width > 991) {
            //                 const photoScroll = document.querySelector('.product-detail__header--photoArea');
            //                 if (photoScroll) {
            //                     animeScroll();
            //                 }
            //             }
            //         });

            //         window.onresize = function () {
            //             const photoScroll = document.querySelector('.product-detail__header--photoArea');
            //             if (photoScroll) {
            //                 if ($('.sidebar__inner').css('position') === 'fixed') {
            //                     const infoArea = document.querySelector('.product-detail__header--infoArea');
            //                     const $container = infoArea ? $(infoArea) : $('.product-detail__header--photoArea');
            //                     const containerWidth = $container.width();
            //                     if (containerWidth) {
            //                         $('.sidebar__inner').css({ width: containerWidth + "px" });
            //                         $('.sidebar__inner').css({ maxWidth: containerWidth + "px" });
            //                     }
            //                 }
            //             }
            //         };
            //     }
            // }
            if (photoArea.classList.contains('gallery-scroll')) {
                let productPhoto = document.querySelector('#product-photo');
                let productImage = productPhoto.querySelector('img');
                let imageHeight = productImage ? productImage.getBoundingClientRect().height : 0;
                productPhoto.style.maxHeight = imageHeight + 'px';

                let thumbsContainer = document.querySelector('.product-detail__header--photoArea-thumbs');
                if (thumbsContainer) {
                    thumbsContainer.style.maxHeight = imageHeight + 'px';
                }

                let thumbsLarge = document.querySelectorAll('#product-photo a');
                let miniThumbs = document.querySelectorAll('.product-detail__header--photoArea-thumbs #photo-list li');
                if (thumbsLarge.length && miniThumbs.length) {
                    miniThumbs.forEach((thumb, index) => {
                        thumb.addEventListener('click', (e) => {
                            // Centraliza a thumb clicada no container de thumbs
                            thumb.scrollIntoView({
                                behavior: 'smooth',
                                block: 'nearest'
                            });

                            // Navega para a foto principal correspondente
                            const target = thumbsLarge[index];
                            if (target) {
                                target.scrollIntoView({
                                    behavior: 'smooth',
                                    block: 'start'
                                });
                            }
                        });
                    });
                }
            }
        },
        updateImageThumb(src) {
            this.imgSrc = src;
        },

        handleESC(event) {
            if (event.key === 'Escape')
                this.showOpened = false
        },

        checkBuyView() {
            const buyButton = document.getElementById("buy-button");
            const rect = buyButton.getBoundingClientRect();

            if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
                const otherElement = document.querySelector(".product-detail__fixed--buy");
                if (otherElement) {
                    otherElement.classList.remove("active");
                }
            } else {
                const otherElement = document.querySelector(".product-detail__fixed--buy");
                if (otherElement) {
                    otherElement.classList.add("active");
                }
            }
        },

        zoom(event) {
            const container = document.getElementById('zoom-container');
            const image = document.getElementById('zoom-image');

            const containerRect = container.getBoundingClientRect();
            const mouseX = event.clientX - containerRect.left;
            const mouseY = event.clientY - containerRect.top;

            if (mouseX >= 0 && mouseX <= containerRect.width && mouseY >= 0 && mouseY <= containerRect.height) {
                const zoomLevel = 1.2;
                const newWidth = container.offsetWidth * zoomLevel;
                const newHeight = container.offsetHeight * zoomLevel;

                const offsetX = -(mouseX * (zoomLevel - 1));
                const offsetY = -(mouseY * (zoomLevel - 1));

                image.style.transform = `translate(${offsetX}px, ${offsetY}px) scale(${zoomLevel})`;

                if (offsetX > 0) {
                    image.style.transform = `translate(0, ${offsetY}px) scale(${zoomLevel})`;
                }
                if (offsetY > 0) {
                    image.style.transform = `translate(${offsetX}px, 0) scale(${zoomLevel})`;
                }
                if (offsetX < -(newWidth - container.offsetWidth)) {
                    image.style.transform = `translate(${- (newWidth - container.offsetWidth)}px, ${offsetY}px) scale(${zoomLevel})`;
                }
                if (offsetY < -(newHeight - container.offsetHeight)) {
                    image.style.transform = `translate(${offsetX}px, ${- (newHeight - container.offsetHeight)}px) scale(${zoomLevel})`;
                }
            }
        },

        resetZoom() {
            const image = document.getElementById('zoom-image');
            image.style.transform = 'translate(0, 0) scale(1)';
        }
    },
    mounted() {

        let description = document.querySelector('.description-nav');
        if (description) {
            let navTab = description.querySelectorAll('.nav-item');
            let navShow = description.querySelectorAll('.description-nav-content');
            navTab = Array.from(navTab);
            navShow = Array.from(navShow);

            if (navTab.length && navShow.length) {
                function toggleTab(index) {
                    const isActive = navTab[index].classList.contains('active');

                    // remove todas as classes active
                    navTab.forEach((content) => content.classList.remove('active'));
                    navShow.forEach((content) => content.classList.remove('active'));

                    // se não estava ativo, ativa
                    if (!isActive) {
                        navTab[index].classList.add('active');
                        navShow[index].classList.add('active');
                    }
                }

                navTab.forEach((itemMenu, index) => {
                    itemMenu.addEventListener('click', () => {
                        toggleTab(index);
                    });
                });
            }
        }

        const groupSizeTitle = document.querySelector('.group-size .group-size-title');
        const productRadioVariation = document.querySelector('.product-radio-variation .label_attributes');
        if (groupSizeTitle && productRadioVariation) {
            groupSizeTitle.textContent = productRadioVariation.textContent;
        }

        waitForElementToExist('.price-cupom').then(element => {
            const priceCupom = document.querySelector('.price-cupom b');

            if (priceCupom) {
                const priceCupomValue = priceCupom.textContent;

                if (priceCupomValue) {
                    let newValue = priceCupomValue;

                    if (priceCupom) {
                        priceCupom.addEventListener("click", (e) => {
                            e.preventDefault();

                            navigator.clipboard.writeText(newValue).then(() => {
                                alert("Valor copiado: " + newValue);
                            }).catch(err => {
                                console.error('Erro ao copiar: ', err);
                                alert("Erro ao copiar o valor.");
                            });
                        });
                    }
                }
            }
        });

        const photoList = document.getElementById("photo-list");
        if (photoList) {
            const firstLi = photoList.querySelector("li");
            if (firstLi) {
                const imgElement = firstLi.querySelector("img");

                if (imgElement) {
                    this.imgSrc = imgElement.getAttribute("src");
                    this.imgTitle = imgElement.getAttribute("title");
                }
            }
        }

        this.clickThumbs();

        const ratingName = document.querySelector('.product-detail__rating__amount');
        if (ratingName !== null)
            if (ratingName.textContent === 'Seja o primeiro a avaliar')
                ratingName.textContent = 'Avaliar';

        const userLetterElement = document.getElementById('user_letter');
        if (userLetterElement) {
            const userLetter = userLetterElement.innerText.trim();
            if (userLetter.length > 0) {
                userLetterElement.innerText = userLetter[0];
            }
        }

        document.addEventListener('keydown', this.handleESC, { passive: true });
        window.addEventListener("scroll", this.checkBuyView, { passive: true });
        window.addEventListener("load", this.checkBuyView, { passive: true });
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.handleESC);
    },
})

$(document).ready(function () {

    if (document.querySelector(".carousel-kit")) {
        var splide = new Splide('.carousel-kit', {
            type: "slide",
            height: 'auto', // Isso aqui ativa o adaptive height
            autoHeight: true,
            autoplay: false,
            rewind: false,
            arrows: false,
            speed: 800,
            perPage: 1,
            perMove: 1,
            drag: false,
            pauseOnFocus: false,
            pagination: false,
            breakpoints: {
                768: {
                    drag: false,
                },
            },
        });

        splide.on('mounted', function () {
            var totalSlides = splide.length;
            var nextButton = document.querySelector('.carousel-kit-next');
            nextButton.setAttribute('data-end', totalSlides - 1);

            var addToCartButtons = document.querySelectorAll('.js-btn__product_detail__add_to_cart');
            addToCartButtons.forEach(button => {
                button.classList.add('no-buy');
            });
            var countDisplay = document.querySelector('.carousel-count');
            countDisplay.textContent = '1/' + totalSlides;
        });

        splide.mount();

        var nextButton = document.querySelector('.carousel-kit-next');
        var observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'data-actual') {
                    var actual = parseInt(nextButton.getAttribute('data-actual'));
                    var end = parseInt(nextButton.getAttribute('data-end'));

                    if (actual === end) {
                        nextButton.classList.add('no-click');
                    } else {
                        nextButton.classList.remove('no-click');
                    }
                }
            });
        });

        // Configurar o observer para monitorar mudanças no atributo data-actual
        observer.observe(nextButton, {
            attributes: true,
            attributeFilter: ['data-actual']
        });
        var prevButton = document.querySelector('.carousel-kit-prev');
        var message = document.querySelector('.carousel-message');
        var addToCartButton = document.querySelector('.js-btn__product_detail__add_to_cart');
        var countDisplay = document.querySelector('.carousel-count');

        nextButton.addEventListener('click', function () {
            var actual = parseInt(nextButton.getAttribute('data-actual'));
            var end = parseInt(nextButton.getAttribute('data-end'));

            if (actual <= end) {
                var activeSlide = document.querySelector('.splide__slide.is-active');
                var radioChecked = activeSlide.querySelector('.product-radio-variation input[type="radio"]:checked');
                var noVariations = activeSlide.querySelector('.js_product_item_kit').getAttribute('data-no-variations');

                if (radioChecked || noVariations) {
                    splide.go('>');
                    actual = Math.min(actual + 1, end);
                    nextButton.setAttribute('data-actual', actual);
                    message.classList.remove('show');
                } else {
                    message.classList.add('show');
                }
            }
        });

        prevButton.addEventListener('click', function () {
            var actual = parseInt(nextButton.getAttribute('data-actual'));
            var end = parseInt(nextButton.getAttribute('data-end'));

            if (actual <= end && actual > 0) {
                splide.go('<');
                actual = Math.max(actual - 1, 0);
                nextButton.setAttribute('data-actual', actual);
            }
        });

        splide.on('move', function () {
            var i = splide.index + 1;
            countDisplay.textContent = i + '/' + splide.length;
        });
    }


    $("body").on("click", ".btn-group.btn-minus", function (event) {
        var $this = $(this);
        var clt = $this.closest(".amount");
        var qt_el = clt.find(".product-detail__qtd--input");
        var qtd = parseInt(qt_el.val());
        if (isNaN(qtd)) {
            qtd = 1;
        }

        if (qtd > 1) qtd--;
        qt_el.val(qtd);
    });

    $("body").on("click", ".btn-group.btn-plus", function (event) {
        var $this = $(this);
        var clt = $this.closest(".amount");
        var qt_el = clt.find(".product-detail__qtd--input");
        var qtd = parseInt(qt_el.val());
        if (isNaN(qtd)) {
            qtd = 1;
        } else {
            qtd++;
        }
        qt_el.val(qtd);
    });

    waitForElementToExist('#js_buy_together_api_layout_1_groups').then(element => {
        const ADD_CART_BTN_SELECTOR = '#js_buy_together_api_add_cart';
        const GROUP_SELECTOR = '#js_buy_together_api_group_0, #js_buy_together_api_group_1, #js_buy_together_api_group_2';

        // Rastreia quais grupos o usuário já selecionou tamanho (não depende do DOM)
        const selectedGroups = new Set();

        const getGroups = () => Array.from(document.querySelectorAll(GROUP_SELECTOR));

        // Garante please-select em grupos novos e atualiza o botão
        const syncUI = () => {
            const groups = getGroups();
            const addCartBtn = document.querySelector(ADD_CART_BTN_SELECTOR);
            if (!addCartBtn) return;

            groups.forEach(group => {
                if (!selectedGroups.has(group.id)) {
                    group.classList.add('please-select');
                }
            });

            const allSelected = groups.length > 0 && groups.every(g => selectedGroups.has(g.id));
            addCartBtn.classList.toggle('no-buy', !allSelected);
        };

        // Marca grupo como selecionado pelo usuário
        const markSelected = (group) => {
            if (!group || !group.id) return;
            selectedGroups.add(group.id);
            group.classList.remove('please-select');
            syncUI();
        };

        const container = document.querySelector('#js_buy_together_api_layout_1_groups');
        if (!container) return;

        // change = seleção em select, radio, checkbox
        container.addEventListener('change', (e) => {
            const target = e.target;
            if (!(target instanceof Element)) return;
            const group = target.closest(GROUP_SELECTOR);
            if (group) markSelected(group);
        }, { passive: true });

        // click em label/input = fallback para radios customizados
        container.addEventListener('click', (e) => {
            const target = e.target;
            if (!(target instanceof Element)) return;
            if (target.closest('label') || target.matches('input')) {
                const group = target.closest(GROUP_SELECTOR);
                if (group) setTimeout(() => markSelected(group), 0);
            }
        }, { passive: true });

        // Observa novos grupos sendo adicionados para colocar please-select
        const observer = new MutationObserver(() => syncUI());
        observer.observe(container, { childList: true, subtree: true });

        // Inicializa
        syncUI();
    });

    let listBuyTogether = document.getElementById('js_buy_together_api_layout_1_groups'),
        options = {
            childList: true
        }
    if (listBuyTogether) {
        observer = new MutationObserver(Callback);
        observer.observe(listBuyTogether, options);

        function Callback() {
            const products = document.querySelectorAll('#js_buy_together_api_layout_1_groups ul');
            if (products.length) {
                products.forEach(product => {
                    if (product.dataset.buyTogetherBound) return;
                    product.dataset.buyTogetherBound = '1';

                    const options = product.querySelector('.product-item__options');
                    if (options) {
                        options.addEventListener('click', () => {
                            const radioVariation = options.querySelector('.product-radio-variation');
                            if (radioVariation) {
                                radioVariation.classList.toggle('active');
                            }
                            product.classList.toggle('active');
                        });

                        if (window.matchMedia("(max-width: 991px)").matches) {
                            const detailList = product.querySelector('.product-item__content--container');
                            if (detailList) {
                                detailList.appendChild(options);
                            }
                        }
                    }
                });
            }
        }
    }

    const brinde = document.querySelector('#js_buy_together_api_layout_2');
    if (brinde) {
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === 1) { // Verifica se o nó é um elemento HTML
                        if (node.id === 'js_buy_together_api_group_1' || node.querySelector('#js_buy_together_api_group_1')) {
                            const targetNode = node.id === 'js_buy_together_api_group_1' ? node : node.querySelector('#js_buy_together_api_group_1');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.product-item__content--figcaption');

                            if (options && figcaption) {
                                figcaption.append(options);
                            }

                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');

                            if (widget && sizes) {
                                widget.addEventListener('click', () => {
                                    sizes.classList.toggle('active');
                                });

                                const allSizes = sizes.querySelectorAll('label');
                                allSizes.forEach(size => {
                                    size.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                        widget.setAttribute('data-before', size.textContent);
                                    });
                                });
                            }
                        }
                        if (node.id === 'js_buy_together_api_group_2' || node.querySelector('#js_buy_together_api_group_2')) {
                            const targetNode = node.id === 'js_buy_together_api_group_2' ? node : node.querySelector('#js_buy_together_api_group_2');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.product-item__content--figcaption');

                            if (options && figcaption) {
                                figcaption.append(options);
                            }

                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');

                            if (widget && sizes) {
                                widget.addEventListener('click', () => {
                                    sizes.classList.toggle('active');
                                });

                                const allSizes = sizes.querySelectorAll('label');
                                allSizes.forEach(size => {
                                    size.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                        widget.setAttribute('data-before', size.textContent);
                                    });
                                });
                            }
                        }
                    }
                });
            });
        });

        observer.observe(brinde, {
            childList: true,
            subtree: true
        });

    }

    const compreJunto = document.querySelector('#js_buy_together_api_layout_1');
    if (compreJunto) {
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === 1) { // Verifica se o nó é um elemento HTML
                        if (node.id === 'js_buy_together_api_group_0' || node.querySelector('#js_buy_together_api_group_0')) {
                            const targetNode = node.id === 'js_buy_together_api_group_0' ? node : node.querySelector('#js_buy_together_api_group_0');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.info-product');

                            if (options && figcaption) {
                                figcaption.append(options);
                            }

                        }
                        if (node.id === 'js_buy_together_api_group_1' || node.querySelector('#js_buy_together_api_group_1')) {
                            const targetNode = node.id === 'js_buy_together_api_group_1' ? node : node.querySelector('#js_buy_together_api_group_1');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.info-product');

                            if (options && figcaption) {
                                figcaption.append(options);
                            }

                        }
                        if (node.id === 'js_buy_together_api_group_2' || node.querySelector('#js_buy_together_api_group_2')) {
                            const targetNode = node.id === 'js_buy_together_api_group_2' ? node : node.querySelector('#js_buy_together_api_group_2');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.info-product');

                            if (options && figcaption) {
                                figcaption.append(options);
                            }

                        }
                    }
                });
            });
        });

        observer.observe(compreJunto, {
            childList: true,
            subtree: true
        });

    }

    if ($('.product-detail__header--photoArea-mobile, .mobile-slider')) {
        $('.product-detail__header--photoArea-mobile, .mobile-slider').slick({
            swipeToSlide: true,
            touchThreshold: 100,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            infinite: false,
            mobileFirst: true,
            speed: 300,
            vertical: false,
            responsive: [
                {
                    breakpoint: 991,
                    settings: "unslick"
                },
            ]
        });
    }

    if ($('#product-detail-related-carrousel').length) {
        $('#product-detail-related-carrousel').slick({
            arrows: false,
            swipeToSlide: true, 
            touchThreshold: 100,
            dots: false,
            infinite: true,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 100,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        arrows: true,
                        slidesToScroll: 4,
                        slidesToShow: 4,
                    }
                },
            ]
        });

        $('#product-detail-related-carrousel').on('afterChange', function(event, slick, currentSlide, nextSlide){
            Blazy({
                selector: '.lazy-img',
                successClass: 'loaded-img',
                success: function(element) {
                    setTimeout(function(){
                        var parent = element.previousSibling;
                        try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/,''); } catch(e){}
                    }, 200);
                }
            });
        });
    }

    if('.banner-como-usam-slider') {
        $('.banner-como-usam-slider').slick({
            swipeToSlide: true,
            touchThreshold: 100,
            arrows: false,
            dots: false,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 3000,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 1000,
            responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToScroll: 1,
                            slidesToShow: 6,
                        }
                    },
                ]
        });
    }

    $('#photo-fancy').fancybox();

    if ($('.product-rating__review-list').length) {
        $('.product-rating__review-list').slick({
            arrows: false,
            dots: false,
            swipeToSlide: true, 
            touchThreshold: 100,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 300,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 5,
                        arrows: true,
                    }
                }
            ]
        });
    }
})